import { IDatePickerProps } from '@coverflex-tech/hypernova';
import { set } from 'date-fns';
import { t } from 'i18next';
import { INTL_MONTH_LONG_FORMAT, intlFormat, now } from './date';

export function monthFormatter(month: number) {
  return intlFormat(set(now(), { month }), INTL_MONTH_LONG_FORMAT);
}

export function weekDayFormatter(day: string) {
  return t(`calendar.${day.toLowerCase()}`);
}

export const datePickerSharedProps: Pick<
  IDatePickerProps,
  'formatMonth' | 'formatWeekDay' | 'i18nKeys'
> = {
  formatMonth: monthFormatter,
  formatWeekDay: weekDayFormatter,
  i18nKeys: {
    previous: t('general.navigation.previous'),
    next: t('general.navigation.next'),
  },
};
